import 'core-js/stable';
import 'core-js/features/string/replace-all';

// For safari 12 and below , dont forget to add locales here
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/de';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/es';
import '@formatjs/intl-pluralrules/locale-data/fr';
import '@formatjs/intl-pluralrules/locale-data/it';
import '@formatjs/intl-pluralrules/locale-data/nl';
import '@formatjs/intl-pluralrules/locale-data/pt';

// --- Harden core DOM mutation methods against third-party monkey-patching ---
// Symptom: "TypeError: Converting circular structure to JSON ... HTMLAnchorElement
// ... __reactFiber$ ... stateNode closes the circle", thrown from inside
// Node.appendChild on React's commit path.
//
// A third-party script (a GTM tag or a browser extension) wraps
// Node.prototype.appendChild and JSON.stringify()s the node it receives. React
// attaches a fiber to every DOM node (node.__reactFiber$ -> fiber.stateNode ->
// node), so serializing any mounted node throws, and since appendChild sits on
// React's commit path the whole render dies.
//
// We restore and lock the native implementations before React mounts. This
// module is imported first in index.js, so in the common case (offending script
// loaded via GTM in App) Node.prototype is still pristine when we capture it.
// A tag that later tries to reassign these methods silently no-ops.
(function hardenDomMutators() {
  const METHODS = ['appendChild', 'insertBefore', 'removeChild', 'replaceChild'];

  // Recover pristine natives from a throwaway same-origin iframe, in case an
  // extension already patched this window's Node.prototype before we ran.
  let natives = null;
  try {
    const frame = document.createElement('iframe');
    frame.style.display = 'none';
    (document.documentElement || document.head).appendChild(frame);
    const frameProto = frame.contentWindow && frame.contentWindow.Node && frame.contentWindow.Node.prototype;
    if (frameProto) {
      natives = {};
      METHODS.forEach(name => {
        natives[name] = frameProto[name];
      });
    }
    frame.remove();
  } catch (e) {
    natives = null;
  }

  METHODS.forEach(name => {
    try {
      const fromFrame = natives && natives[name];
      const native = typeof fromFrame === 'function' ? fromFrame : Node.prototype[name];
      if (typeof native !== 'function') return;
      Object.defineProperty(Node.prototype, name, {
        value: native,
        writable: false,
        configurable: false,
      });
    } catch (e) {
      // best-effort hardening; never block startup
    }
  });
})();
